import React from 'react';
import ReactDOM from 'react-dom/client';
import { initTheme } from '@desktop/theme';

import { App } from './App';
// 外殼樣式要排在 Desktop 全域樣式之後，html/body 的覆寫才會生效。
import './desktop-editor.css';
import './styles.css';

// 與桌面版共用主題偏好（localStorage），外殼與編輯器一起切換淺色／深色／跟隨系統。
initTheme();

const container = document.getElementById('root');
if (container === null) throw new Error('#root not found');

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
